'use client'

import FeatureTiles from './FeatureTiles'
import { formatFontFamily } from '@/lib/themeHelpers'

interface CampaignSectionProps {
  surface: "dark" | "light";
  theme: any;
  radius: number;
  fontFamily: string;
  gradStart: string;
  gradEnd: string;
  angle: number;
  iconWeight: string;
  content: any;
}

export default function CampaignSection({
  surface,
  theme,
  radius,
  fontFamily,
  gradStart,
  gradEnd,
  angle,
  iconWeight,
  content
}: CampaignSectionProps) {
  const backgroundStyle = {
    backgroundImage: surface === "dark" 
      ? `linear-gradient(${angle}deg, ${gradStart}, ${gradEnd})`
      : `linear-gradient(${angle}deg, #f8f9fa, #e9ecef)`,
    fontFamily: formatFontFamily(fontFamily)
  };

  return (
    <section className="relative isolate overflow-hidden" style={backgroundStyle}>
      <div className="mx-auto max-w-6xl px-6 py-24 lg:px-8">
        {/* Centered Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold font-primary" style={{ color: theme.text }}>
            {content.title}
          </h2>
          <p className="mt-4 text-lg font-primary" style={{ color: theme.mutedText }}>
            {content.description}
          </p>
        </div>

        {/* Two Column Layout */}
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2">
          
          {/* Left Column - Campaign Planning Card */}
          <div className="p-8" style={{
            backgroundColor: theme.card,
            border: `1px solid ${theme.border}`,
            borderRadius: radius
          }}>
            <h3 className="text-2xl font-semibold mb-6 font-primary" style={{ color: '#FFFFFF' }}>
              {content.planningCard.title}
            </h3>
            
            <ul className="space-y-4 mb-8">
              {content.planningCard.features.map((feature: string, index: number) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full mt-2" style={{ backgroundColor: '#FFFFFF' }}></div>
                  <span className="font-secondary" style={{ color: theme.mutedText }}>{feature}</span>
                </li>
              ))}
            </ul>
            
            <button 
              className="px-6 py-3 text-sm font-semibold shadow-lg transition-all duration-200 hover:shadow-xl font-primary"
              style={{
                background: theme.button,
                color: theme.onButton,
                borderRadius: radius,
                border: 'none'
              }}
              onClick={() => (window as any).ChatWidget?.showChat()}
            >
              {content.planningCard.ctaText}
            </button>
          </div>

          {/* Right Column - Feature Tiles Grid */}
          <FeatureTiles theme={theme} radius={radius} iconWeight={iconWeight} />
        </div>
      </div>
    </section>
  );
}
